{
    "RangeCombo_Search_Placeholder": "Ricerca...",
    "NAME": "RangeComboLanguage",
    "Validation_Generic_Error_Message": "Attualmente sono stati rilevati 1 o più errori",
    "Validation_Generic_Error_Max_Entries": "Hai raggiunto\/superato il numero massimo di iscrizioni."
}